<template>
    <div class="p-10">
        <template v-if="loadingInit">
            <div class="flex flex-col items-center justify-center min-h-screen">
                <div class="text-center">
                    <div class="mb-8">
                        <i class="fas fa-music text-6xl text-blue-500 animate-bounce"></i>
                    </div>
                    <h2 class="text-3xl font-bold text-gray-800 mb-4">Chargement de la partie...</h2>
                    <div class="flex justify-center gap-2 mb-6 pt-4">
                        <div class="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                        <div class="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style="animation-delay: 0.2s;"></div>
                        <div class="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style="animation-delay: 0.4s;"></div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="partie">
            <div class="flex items-center justify-between">
                <div>ID Partie: {{ partie.token }}</div>
                <button @click="quitGame">Quitter</button>
            </div>

            <template v-if="!displayResponses">
                <!-- Au tour de -->
                <div v-if="scores && tour && !myTurn" class="mt-5">
                    <div class="mt-5">
                        <h2 class="text-xl font-bold mb-2">Scores</h2>
                        <div class="space-y-2">
                            <div v-for="joueur in scores" :key="joueur.id" class="flex justify-between items-center bg-gray-100 p-3 rounded-lg">
                                <span class="font-semibold text-gray-800">{{ joueur.nom }}</span>
                                <span class="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-bold">{{ joueur.score }} pts</span>
                            </div>
                        </div>
                    </div>

                    <template v-if="!hasSendCard">
                        <h2 class="text-xl font-bold mb-2 mt-5">Au tour de</h2>
                        <div v-if="tour && scores">
                            <div class="px-4 py-3 bg-green-100 rounded text-xl">
                                <i class="fas fa-music mr-2"></i>
                                <span class="font-bold">{{ scores.find((item) => item.id === tour)?.nom }}</span>
                            </div>
                        </div>
                        <div v-else>
                            <p>Aucun tour en cours.</p>
                        </div>

                        <div class="mt-5 bg-slate-50 p-4 rounded-lg shadow">
                            <h2 class="text-xl font-bold mb-3">Placez votre carte</h2>

                            <div>
                                <div v-if="responses.length > 0">

                                    <!-- Avant la première réponse -->
                                    <div class="mb-2">
                                        <template v-if="placementIndex === 0">
                                            <!-- FORMULAIRE ICI -->
                                            <div class="p-4 bg-yellow-200 rounded shadow">
                                                <div class="font-bold">🎯 Choisir l'année</div>
                                                <input type="number" v-model="inpYear" class="border p-2 rounded w-full mt-3">
                                                <button 
                                                    class="bg-blue-600 text-white px-4 py-2 rounded w-full mt-3"
                                                    @click="validerPlacement"
                                                >
                                                    Valider
                                                </button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <button 
                                                class="bg-yellow-300 w-full py-2 rounded font-bold"
                                                @click="choosePlacement(null, responses[0].id, 0)"
                                            >
                                                Placer ICI (avant {{ responses[0].response }})
                                            </button>
                                        </template>
                                    </div>

                                    <!-- Boucle cartes + boutons au milieu -->
                                    <div v-for="(item, idx) in responses" :key="item.id">

                                        <!-- Carte réponse -->
                                        <div class="p-4 bg-gray-100 rounded-lg mb-2 shadow flex items-center justify-between">
                                            <div class="text-2xl font-bold">{{ item.response }}</div>
                                            <div class="flex items-center gap-2">
                                                <img :src="item.cover" class="h-[40px]" alt="">
                                                <div class="text-sm font-light">
                                                    <div class="font-bold">{{ item.titre }}</div>
                                                    <div>{{ item.artist }}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Bouton / formulaire entre carte idx et idx+1 -->
                                        <div class="mb-2">

                                            <template v-if="placementIndex === idx + 1">
                                                <!-- FORMULAIRE ICI -->
                                                <div class="p-4 bg-yellow-200 rounded shadow">
                                                    <div class="font-bold">🎯 Choisir l'année</div>
                                                    <input type="number" v-model="inpYear" class="border p-2 rounded w-full mt-3">
                                                    <button 
                                                        class="bg-blue-600 text-white px-4 py-2 rounded w-full mt-3"
                                                        @click="validerPlacement"
                                                    >
                                                        Valider
                                                    </button>
                                                </div>
                                            </template>

                                            <template v-else-if="idx < responses.length - 1">
                                                <button 
                                                    class="bg-yellow-300 w-full py-2 rounded font-bold"
                                                    @click="choosePlacement(item.id, responses[idx+1].id, idx + 1)"
                                                >
                                                    Placer ICI (entre {{ item.response }} et {{ responses[idx+1].response }})
                                                </button>
                                            </template>

                                        </div>

                                    </div>

                                    <!-- Après la dernière réponse -->
                                    <div class="mt-2">
                                        <template v-if="placementIndex === responses.length">
                                            <!-- FORMULAIRE ICI -->
                                            <div class="p-4 bg-yellow-200 rounded shadow">
                                                <div class="font-bold">🎯 Choisir l'année</div>
                                                <input type="number" v-model="inpYear" class="border p-2 rounded w-full mt-3">
                                                <button 
                                                    class="bg-blue-600 text-white px-4 py-2 rounded w-full mt-3"
                                                    @click="validerPlacement"
                                                >
                                                    Valider
                                                </button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <button 
                                                class="bg-yellow-300 w-full py-2 rounded font-bold"
                                                @click="choosePlacement(responses[responses.length-1].id, null, responses.length)"
                                            >
                                                Placer ICI (après {{ responses[responses.length-1].response }})
                                            </button>
                                        </template>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="hasSendCard">
                        <div class="mt-5 p-4 bg-green-100 rounded-lg text-center font-bold">
                            Vous avez placé votre carte.<br />
                            En attente de la fin du tour.
                        </div>
                    </template>
                </div>

                <!-- Choisir la musique -->
                <div v-if="scores && tour && myTurn" class="mt-5">
                    <template v-if="!selectedTrack">
                        <h2 class="text-xl font-bold mb-2">Choisir la musique</h2>
                        <div @click="playTrack(track)" v-if="track.track.name" v-for="(track, trackIndex) in myTracks" :key="'track-' + trackIndex" class="p-4 bg-gray-100 rounded-lg mb-4">
                            <div class="flex items-center gap-2">
                                <img :src="track.track.album.images[2]?.url" class="h-[40px]" alt="">
                                <div>
                                    <div class="text-lg font-bold">{{ track.track.name }}</div>
                                    <div class="text-sm font-light">{{ track.track.artists[0].name }}</div>
                                </div>
                            </div>
                            <!-- <div class="text-sm font-light">{{ track.artists.join(', ') }}</div> -->
                            <!-- <div class="text-sm font-light">Année de sortie: {{ track.year }}</div> -->
                        </div>
            
                        <template v-if="isLoadingMore">
                            <i class="fas fa-spinner fa-spin"></i> Chargement...
                        </template>
                    </template>

                    <template v-if="selectedTrack">
                        <h2 class="text-xl font-bold mb-2">Musique sélectionnée</h2>
                        <div class="flex items-center gap-4 p-4 bg-gray-100 rounded-lg mb-4">
                            <img :src="selectedTrack.track.album.images[2]?.url" class="h-[60px]" alt="">
                            <div>
                                <div class="text-lg font-bold">{{ selectedTrack.track.name }}</div>
                                <div class="text-sm font-light">{{ selectedTrack.track.artists[0].name }}</div>
                                <div class="text-sm font-light">Année de sortie: {{ selectedTrack.track.album.release_date.split('-')[0] }}</div>
                            </div>
                        </div>
                        <!-- Attente de réponse -->
                        <div>
                            <i class="fas fa-spinner fa-spin"></i> En attente des réponses...
                        </div>
                    </template>
                </div>
            </template>
            <template v-if="displayResponses">
                <!-- Année correcte -->
                <div class="bg-green-600 font-bold text-white p-4 rounded text-center text-xl mt-5">
                    🎉 L'année correcte est : <div class="text-3xl font-bold">{{ displayResponses.annee }}</div>
                </div>

                <!-- Les réponses -->
                <div class="mt-4">
                    <div v-for="(response, index) in displayResponses.responses" :key="index" class="flex items-center justify-between p-2 border-b">
                        <div>
                            <strong>{{ response.account.nom }}</strong> : {{ response.response_user }}
                        </div>
                        <div>
                            <span class="font-bold" :class="{'text-green-800': response.response_user === displayResponses.annee, 'text-slate-8800': response.response_user !== displayResponses.annee}">
                                {{ response.score }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Prochain tour -->
                <template v-if="myTurn">
                    <div class="mt-6">
                        <button @click="nextTour" class="bg-blue-600 text-white px-4 py-2 rounded w-full">
                            Prochain tour
                        </button>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    data() {
        return {
            account: null,
            partie: null,
            tour: null,
            scores: [],

            inpYear: '',

            loadingInit: false,
            loadingWaitingPlayers: false,

            trackNext: null,
            myTracks: [],
            isLoadingMore: false,
            noMoreTracks: false,

            responses: [],

            selectedTrack: null,

            placementSelected: false,
            beforeId: null,
            afterId: null,
            placementIndex: null,
            yearMin: null,
            yearMax: null,
            sortable: null,
            timelineItems: [],
            hasSendCard: false,
            loadingSendCard: false,

            displayResponses: null,
        }
    },
    computed: {
        myTurn() {
            return this.tour == this.account.id;
        },
    },
    methods: {
        quitGame() {
            if (confirm("Voulez-vous vraiment quitter la partie ?")) {
                this.$router.push({ name: 'Home' });
            }
        },
        async getAccount() {
            let response = await this.$request.post('/get-account', {
                token: localStorage.getItem('user-token')
            });
            this.account = response;
        },
        async getPartie() {
            let response = await this.$request.post('/partie/get-partie', {
                partie_token: this.$route.params.partieToken
            })
            this.partie = response;
        },
        async getTour() {
            let response = await this.$request.post('/partie/get-tour', {
                partie_token: this.$route.params.partieToken
            })
            this.tour = response;

            if (this.myTurn) {
                await this.getMyLikes();
            }
        },
        async getScores() {
            let response = await this.$request.post('/partie/get-scores', {
                partie_token: this.$route.params.partieToken
            })
            this.scores = response;
        },

        async getMyLikes() {
            this.myTracks = [];
            this.trackNext = '/spotify/my-liked-tracks';

            this.isLoadingMore = true;

            let response = await this.$request.post(this.trackNext, {
                token: localStorage.getItem('user-token')
            });

            this.myTracks = response.items;
            this.trackNext = response.next;

            this.isLoadingMore = false;
        },

        async handleScroll() {
            // Ne rien charger si ce n'est pas ton tour
            if (!this.myTurn) return;

            // Si pas de next -> fini
            if (!this.trackNext || this.trackNext === null) return;

            // Si déjà en train de récupérer -> bloque
            if (this.isLoadingMore) return;

            const scrollBottom = window.innerHeight + window.scrollY;
            const pageHeight = document.body.offsetHeight;

            // Seuil de déclenchement (ex: 150px avant le bas)
            if (scrollBottom + 150 >= pageHeight) {
                await this.loadMoreTracks();
            }
        },

        async loadMoreTracks() {
            // Si pas de next → rien à charger
            if (!this.trackNext || this.trackNext === null) return;

            // Anti-spam : déjà en train de charger
            if (this.isLoadingMore) return;
            this.isLoadingMore = true;

            try {
                // Si Spotify renvoie une URL complète → on extrait juste l'endpoint
                let endpoint = this.extractEndpointFromSpotifyUrl(this.trackNext);

                // Appel au proxy Laravel
                let response = await this.$request.post('/spotify/proxy', {
                    partie_token: this.$route.params.partieToken,
                    endpoint: endpoint
                });

                // Ajoute les nouveaux titres
                if (response.items && response.items.length > 0) {
                    this.myTracks.push(...response.items);
                }

                // Nouveau "next" (null si plus de pages)
                this.trackNext = response.next || null;

                // Si null → fin des résultats
                if (!this.trackNext) {
                    this.noMoreTracks = true;
                }

            } catch (e) {
                console.error("Erreur loadMoreTracks:", e);
            }

            // Libère le lock
            this.isLoadingMore = false;
        },

        extractEndpointFromSpotifyUrl(url) {
            try {
                const u = new URL(url);
                // retire le /v1/
                return u.pathname.replace('/v1/', '') + u.search;
            } catch (e) {
                console.error("Erreur parsing next URL:", url);
                return null;
            }
        },

        async playTrack(track) {
            this.selectedTrack = track;
            try {
                await this.$request.post('/spotify/play', {
                    track_id: track.track.id,
                    partie_token: this.$route.params.partieToken,
                    cover: track.track.album.images[2]?.url,
                    titre: track.track.name,
                    artist: track.track.artists[0]?.name,
                    annee: track.track.album.release_date.split('-')[0]
                });
            } catch (e) {
                console.error("Erreur playTrack:", e);
            }
        },
        async getMyResponses() {
            this.loadingWaitingPlayers = true;

            let response = await this.$request.post('partie/my-responses', {
                partie_token: this.$route.params.partieToken,
                token: localStorage.getItem('user-token')
            });

            this.responses = response;
        },

        choosePlacement(beforeId, afterId, index) {
            this.beforeId = beforeId;
            this.afterId = afterId;
            this.placementIndex = index;   // emplacement dans les boutons
            this.inpYear = '';             // reset année
        },

        async validerPlacement() {
            if (!this.inpYear) {
                this.$toast.error('Veuillez entrer une année.');
                return;
            }

            try {
                this.loadingSendCard = true;

                await this.$request.post('/partie/add-reponse', {
                    partie_token: this.$route.params.partieToken,
                    token: localStorage.getItem('user-token'),
                    response_user: this.inpYear,
                    before_id: this.beforeId,
                    after_id: this.afterId
                });

                this.hasSendCard = true;
                this.placementSelected = false;

            } catch (e) {
                console.error('Erreur addReponse', e);
                this.$toast.error('Erreur lors de l’envoi.');
            }

            this.loadingSendCard = false;
        },

        async nextTour() {
            await this.$request.post('/partie/next-tour', {
                partie_token: this.$route.params.partieToken
            })
        },

        async resetTour() {
            this.loadingInit = true;

            this.selectedTrack = null;
            this.hasSendCard = false;
            this.placementIndex = null
            this.displayResponses = null;

            this.inpYear = '';
            this.loadingWaitingPlayers = false;

            this.trackNext = null
            this.myTracks = []
            this.isLoadingMore = false
            this.noMoreTracks = false

            this.placedBeforeId = null
            this.placedAfterId = null
            this.yearMin = null
            this.yearMax = null
            this.sortable = null
            this.timelineItems = []
            this.hasSendCard = false
            this.loadingSendCard = false

            this.displayResponses = null

            await this.getPartie();
            await this.getTour();
            await this.getScores();
            await this.getMyResponses();

            this.loadingInit = false;
        }
    },
    async mounted() {
        this.loadingInit = true;

        await this.getAccount();
        await this.resetTour();
        this.loadingInit = false;
        
        
        this.$nextTick(() => {
            // ADD SCROLL LISTENER POUR CHARGEMENT INFINI
            window.addEventListener('scroll', this.handleScroll);

            this.$websocket.receive("display-response-" + this.partie.token, data => {
                console.log("Réception display-response:", data);
                this.displayResponses = data
            });
    
            this.$websocket.receive("next-tour-" + this.partie.token, async data => {
                console.log("Réception next-tour:", data);
                this.resetTour();
            });
        })
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
